module.exports = __webpack_public_path__ + "img/light-search.5cba56c7.svg";